import React from 'react';

const LoadingSpinner = ({ text = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center py-20">
    <div className="relative w-12 h-12 mb-4">
      <div className="absolute inset-0 rounded-full border-[3px] border-gray-100"></div>
      <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-primary-600 animate-spin"></div>
    </div>
    <p className="text-gray-400 text-sm font-medium">{text}</p>
  </div>
);

export default LoadingSpinner;

